import { lazy, Suspense } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClientProvider } from "@tanstack/react-query";
import { QueryClient } from "@tanstack/query-core";
import { BrowserRouter, Routes, Route } from "react-router";
import { HelmetProvider } from "react-helmet-async";
import { HiddenBlessing } from "./components/HiddenBlessing";
import Index from "./pages/Index";

const Privacy = lazy(() => import("./pages/Privacy"));
const Terms = lazy(() => import("./pages/Terms"));
const Admin = lazy(() => import("./pages/Admin"));
const AdminLogin = lazy(() => import("./pages/AdminLogin"));
const DonationSuccess = lazy(() => import("./pages/DonationSuccess"));
const StripeSetupGuide = lazy(() => import("./pages/StripeSetupGuide"));
const AdminChecklist = lazy(() => import("./pages/AdminChecklist"));
const CookiePolicy = lazy(() => import("./pages/CookiePolicy"));
const AdminHealth = lazy(() => import("./pages/AdminHealth"));
const AdminStatus = lazy(() => import("./pages/AdminStatus"));
const AdminExecutionGuide = lazy(() => import("./pages/AdminExecutionGuide"));
const Unsubscribe = lazy(() => import("./pages/Unsubscribe"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();
const HelmetProviderAny = HelmetProvider as any;

const App = () => (
  <HelmetProviderAny>
    <HiddenBlessing />
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Suspense fallback={<div className="min-h-screen" />}>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/donation-success" element={<DonationSuccess />} />
              <Route path="/stripe-setup-guide" element={<StripeSetupGuide />} />
              <Route path="/admin-checklist" element={<AdminChecklist />} />
              <Route path="/cookies" element={<CookiePolicy />} />
              <Route path="/admin/health" element={<AdminHealth />} />
              <Route path="/admin/status" element={<AdminStatus />} />
              <Route path="/admin/execution-guide" element={<AdminExecutionGuide />} />
              <Route path="/unsubscribe" element={<Unsubscribe />} />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProviderAny>
);

export default App;
